import { takeEvery, all, fork, put } from "redux-saga/effects";
import {
  GET_ALL_SERVICES,
  GET_TIME_SLOTS,
  BOOK_CUSTOMER_APPOINTMENT,
  GET_ALL_IDS,
} from "../constants/ActionTypes";
import axios from "../services/customer";
import * as actions from "../actions";

function* responseForTimeSlots({ payload }) {
  try {
    const { from, to, employeeSelected: employee, serviceSelected: service, branch } = payload;

    const response = yield axios.post("/availableslots", {
      from,
      to,
      service,
      employee,
      branch,
    });
    // chage of booking data by response.data
    yield put(actions.setTimeSlots(response.data[0]));
  } catch (error) {}
}

function* responseForServices(action) {
  try {
    const response = yield axios.post("/bookappointment/", {
      business_location: action.id._id,
    });

    yield put(actions.setAllServices(response.data));
  } catch (error) {}
}

function* requestForBusineesId(action) {
  try {
    const response = yield axios.get(`/businesses?business_slug=${action.id}`);
    // yield put(actions.getAllServices(response.data[0].business_locations[0]));
    
    const data = yield {
      employees_working: response.data[0].employees_working,
      services_offered: response.data[0].business_locations[0].services_offered,
      operations: response.data[0].business_locations[0].operations,
      business_name: response.data[0].name,
      businesslocation_id: response.data[0].business_locations[0]._id
    }
    yield put(actions.setAllServices(data));
  } catch (error) {}
}

function* bookCustomerAppointment(action) {
  try {
    const response = yield axios.post("/appointments/", {
      from: action.payload.from,
      to: action.payload.to,
      status: "booked",
      employee: action.payload.employeeId,
      service: action.payload.serviceId,
      duration: action.payload.duration,
      price: action.payload.price,
      firstname: action.payload.firstName,
      lastname: action.payload.lastName,
      email: action.payload.email,
      phonenumber: action.payload.phoneNumber,
      message: action.payload.message ? action.payload.message : "",
      location: action.payload.location,
      remindersent: false,
      businessname: action.payload.businessname,
    });

    yield put(actions.setConfirmationPage(response.data));
  } catch (error) {}
}

export function* requestAllServices() {
  yield takeEvery(GET_ALL_SERVICES, responseForServices);
}

export function* requestWeekTimeSlots() {
  yield takeEvery(GET_TIME_SLOTS, responseForTimeSlots);
}

export function* requestAllIDs() {
  yield takeEvery(GET_ALL_IDS, requestForBusineesId);
}
export function* bookAppointment() {
  yield takeEvery(BOOK_CUSTOMER_APPOINTMENT, bookCustomerAppointment);
}

export default function* rootSaga() {
  yield all([
    fork(requestAllIDs),
    fork(requestAllServices),
    fork(requestWeekTimeSlots),
    fork(bookAppointment),
  ]);
}



// WEBPACK FOOTER //
// ./sagas/BookAppointment.js